import { Injectable, Injector } from '@angular/core';
import { HttpDataService } from './http-data.service';
import { lastValueFrom } from 'rxjs';

@Injectable()
export class TasksService extends HttpDataService {
  constructor(protected injector: Injector) {
    super(injector, '/tasks');
  }

  execute(taskName: string, payload: any): Promise<any> {
    const url = `${this.baseUrl}/${taskName}/run`;
    return super.postRequest(url, payload, this.getRequestOptions());
  }

  getScheduledTasks(): Promise<any> {
    const url = `${this.baseUrl}/scheduled`;
    return lastValueFrom(this.http.get(url, this.getRequestOptions())).catch((error) => this.handlePromiseError(error));
  }

  runScheduledTasks(payload) {
    const url = `${this.baseUrl}/scheduled`;
    return super.postRequest(url, payload, this.getRequestOptions());
  }

  getFetchUrl() {
    return `${this.baseUrl}/scheduled/results`;
  }
}
